/** Debe coincidir con el API Node (`realtimeHub.ts`). */
export const PUBLIC_REGISTRATION_NEW_PENDING_EVENT =
  "publicRegistration:newPending";

export const MEDICAL_RECORD_PENDING_REVIEW_EVENT = "medicalRecord:pendingReview";
